module.exports = __webpack_public_path__ + "static/media/75_068e1f3d_1_.ab1aee30.jpg";